module.exports = __webpack_public_path__ + "img/treeplant6_7-8-2021.b97af67e.jpg";